angular
  .module("app", [
    "ui.toggle",
    "summernote",
    "ngFileUpload",
    "datetimepicker",
    "localytics.directives",
    "ngSanitize",
    "ngMask",
    "yaru22.angular-timeago",
    "vcRecaptcha",
    "ui.calendar",
    "ngTagsInput",
    "angucomplete-alt",
    "ui.sortable",
    "ui.bootstrap",
  ])
  .config(function ($interpolateProvider) {
    $interpolateProvider.startSymbol("<%").endSymbol("%>");
  })
  .config([
    "chosenProvider",
    function (chosenProvider) {
      chosenProvider.setOption({
        no_results_text: "Nenhum resultado!",

        allow_single_deselect: true,
      });
    },
  ]);
